import React from 'react';
import { translate } from 'react-i18next';

import UIStatusDialog from 'components/UIStatusDialog.js';
import ExistingCalendarShares from 'components/account/ExistingCalendarShares.js';
import UserActions from 'actions/UserActions.js';

class AccountCalendarSync extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      copyButtonText: this.props.t('AccountCalendarSync.copy_url'),
      emailError: false,
      email: '',
      errorText: '',
      serverError: false,
      statuses: [],
    };

    this.copySyncUrl = this.copySyncUrl.bind(this);
  }

  componentDidMount() {
    this.setState({
      statuses: [],
    });
    UserStore.on('user:shared:sent:calendar:error', this._onErrorSendCalendar.bind(this));
  }

  componentWillUnmount() {
    // remove store event handlers
    UserStore.off(null, null, this);
    this.setState({
      statuses: [],
    });
  }

  parseShareData(data) {
    data.map(function (share) {
      if (share.email == this.props.user.email) {
        this.setState({
          selfSubscribeUrl: share.url,
        });
      }
    }, this);
  }

  componentWillReceiveProps(nextProps) {
    this.state.email = '';
    if (!_.isEmpty(nextProps.shareData)) {
      this.parseShareData(nextProps.shareData);
    }
  }

  _onErrorSendCalendar(collection, error) {
    let errorData;
    if (error.responseText) {
      errorData = error.responseJSON;
    } else {
      errorData = error;
    }
    this.setState({ emailError: true, errorText: errorData.error_message });
  }

  handleCalendarShare(e) {
    e.preventDefault();
    if (!Utils.validateEmail(this.state.email)) {
      this.setState({ emailError: true, errorText: this.props.t('AccountCalendarSync.email_invalid') });
    } else {
      this.setState({ emailError: false, errorText: '' });
      if (UserActions) {
        UserActions.sendSharedCalendar(this.state.email);
      }
    }
  }

  closeStatusDialog(props) {
    this.props.closeStatusDialog(props);
  }

  handleChange(e) {
    this.setState({
      email: e.target.value,
    });
  }

  copySyncUrl(e) {
    e.preventDefault();

    // select all text in the url sync text box
    this.refs.urlSync.select();

    // copy the link to the system clipboard
    document.execCommand('copy');
    this.setState({
      copyButtonText: this.props.t('AccountCalendarSync.url_copied'),
    });

    setTimeout(() => {
      this.setState({ copyButtonText: this.props.t('AccountCalendarSync.copy_url') });
    }, 3000);
  }

  render() {
    // preventing defaultValues being set before the data is available.
    if (!this.props.shouldRender) {
      return false;
    }

    // validate email input classes and error text if needed
    let emailErrorClass = '';
    let emailErrorText = '';
    if (this.state.emailError) {
      emailErrorClass = 'field-error';
      emailErrorText = this.state.errorText;
    }

    const statusDialogs = [];
    _.each(
      this.props.statuses,
      function (status) {
        statusDialogs.push(
          <UIStatusDialog
            status={status}
            key={_.uniqueId()}
            closeDialog={this.closeStatusDialog.bind(this)}
          />,
        );
      },
      this,
    );

    const ownCalendarUrl = this.state.selfSubscribeUrl || '';
    const hasShares = this.props.shareData.length > 1;
    const canCopy = document.queryCommandEnabled('copy') || document.queryCommandSupported('copy');
    const { copyButtonText } = this.state;

    return (
      <div className={this.props.activeState}>
        <form className="contact-info calendar-sync">
          <fieldset>
            <legend>
              <h1>{this.props.t('AccountCalendarSync.sync_to_your_calendar')}</h1>
            </legend>
            <div className="url-sync">
              <label htmlFor="url-sync">
                {this.props.t('AccountCalendarSync.use_this_url')}
                {' '}
              </label>
              <input ref="urlSync" name="url-sync" type="text" value={ownCalendarUrl} readOnly />
              {canCopy && (
                <button onClick={this.copySyncUrl} name="copy-sync-url" id="copy-sync-url">
                  <span ref="copy-button-text">{copyButtonText}</span>
                </button>
              )}
            </div>
            <div id="for-more-help">
              {window.EmployeeWeb.ENVConfig.brand !== 'adp'
                ? this.props.t('AccountCalendarSync.for_more_help')
                : this.props.t('AccountCalendarSync.for_more_help_alt')
              }
              <p>
                <a target="_blank" href={window.EmployeeWeb.ENVConfig.google_calendar_support_link}>
                  {this.props.t('AccountCalendarSync.syncing_with_google')}
                </a>
              </p>
              <p>
                <a
                  target="_blank"
                  href={window.EmployeeWeb.ENVConfig.outlook_calendar_support_link}
                >
                  {this.props.t('AccountCalendarSync.syncing_with_microsoft')}
                </a>
              </p>
              <p>
                <a target="_blank" href={window.EmployeeWeb.ENVConfig.apple_calendar_support_link}>

                {this.props.t('AccountCalendarSync.syncing_with_apple')}
                </a>
              </p>
            </div>
          </fieldset>

          <div className="hr"></div>

          <fieldset>
            <legend>
              <h1>{this.props.t('AccountCalendarSync.share_your_schedule')}</h1>
            </legend>
            <p>
              {this.props.t('AccountCalendarSync.share_instructions')}
            </p>
            <div className="share-your-calendar">
              <label htmlFor="email">{this.props.t('AccountCalendarSync.email_address')}</label>
              <input
                name="email"
                type="email"
                value={this.state.email}
                onChange={this.handleChange.bind(this)}
                className={emailErrorClass}
              />
              <button
                className="send-calendar"
                onClick={this.handleCalendarShare.bind(this)}
                defaultValue="Send"
              >
                {this.props.t('AccountCalendarSync.share_schedule')}
              </button>
              <p className="error-message">{emailErrorText}</p>
            </div>
          </fieldset>
        </form>
        {hasShares && (
          <ExistingCalendarShares user={this.props.user} shareData={this.props.shareData} />
        )}
        {statusDialogs}
      </div>
    );
  }
}

export default translate()(AccountCalendarSync);
